'use client';

import { ColorMode, localStorageManager } from '@chakra-ui/react';
import { ModalsProvider, SaasProvider } from '@saas-ui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { IntlProvider } from 'react-intl';

import { Link } from '@/components/common';
import { StableNavigateProvider } from '@/context/stableNavigate';
import { queryClient } from '@/lib/react-query';
import { theme } from '@/theme';

// In a Vite (non-SSR) app, we can use Chakra's built-in localStorageManager
const colorModeManager = localStorageManager;

interface AppProviderProps {
  onError?: (error: Error, info: unknown) => void;
  initialColorMode?: ColorMode;
  children: React.ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = props => {
  const { onError, children } = props;

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <SaasProvider
        linkComponent={Link}
        onError={onError}
        theme={theme}
        colorModeManager={colorModeManager}
      >
        <IntlProvider locale='en-US' defaultLocale='en-US'>
          <ModalsProvider>
            <StableNavigateProvider>{children}</StableNavigateProvider>
          </ModalsProvider>
        </IntlProvider>
      </SaasProvider>
    </QueryClientProvider>
  );
};
